<template>
  <div class="public-container">
    <div class="public-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/public-banner.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">公共图书馆特色方案</h2>
          <p class="banner-desc" style="width:34.4rem">
            博库公共图书馆特色解决方案利用新技术视觉窗口，来为读者全方位展现公共文化。从读者的导览导视、大屏阅读、多屏互动等视觉需求出发，而设计的公共图书馆特色方案，能够大大增加公图的环境水平和文化内涵。
          </p>
        </div>
      </div>
    </div>
    <!-- 智能线上线下导览导视 -->
    <div class="public-container-guide">
      <h2 class="public-container-guide-title title-common">
        智能线上线下导览导视
      </h2>
      <p class="public-container-guide-p">线下智能导览导视系统</p>
      <div class="public-container-guide-pic">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/libpublic/public-index-guide-fixed.png"
          alt=""
        />
        <p class="public-container-guide-pic-p">
          智能导览导视借助全景地图拍摄技术，生成图书馆的全景三维地图，帮助图书馆告别传统的平面导航，升级为全方位无死角的全景导航。同时，一体机也支持图书馆平面导览、综合信息发布、图书检索等功能。
        </p>
      </div>
      <p class="public-container-guide-p">线上云端导览系统</p>
      <div class="public-container-guide-content">
        <div class="public-container-guide-content-left">
          <p class="public-container-guide-content-left-desc">
            智能导览导视借助全景地图拍摄技术，生成图书馆的全景三维地图，帮助图书馆告别传统的平面导航，升级为全方位无死角的全景导航。同时，一体机也支持图书馆平面导览、综合信息发布、图书检索等功能。
          </p>
        </div>
        <div class="public-container-guide-content-right">
          <img
            src="https://image.bookgo.com.cn/bgOfficial/libpublic/public-index-guide-pic1.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 多屏互动展示系统 -->
    <div class="public-container-multiScreen">
      <h2 class="public-container-multiScreen-title title-common">
        多屏互动展示系统
      </h2>
      <div class="public-container-multiScreen-content">
        <div class="public-container-multiScreen-content-inner">
          <p class="public-container-multiScreen-content-inner-head">
            多屏互动显示系统是由互动智能大屏和管理平台组成。互动智能大屏包含信息发布系统、人物展示类纸画屏系统、新书互动系统、类纸画屏动态展示系统、多媒体互动大屏系统、时间轴互动系统等智能系统。管理平台可实现多媒体信息发布、多业务软件协同、远程发布、多设备实时管理等功能。
          </p>
          <el-carousel :interval="4000" type="card" height="25rem">
            <el-carousel-item v-for="(item, i) in picList" :key="i">
              <img :src="item.pic" alt="" />
              <p>{{ item.desc }}</p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      picList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/libpublic/public-item1.png",
          desc: "人物展示类纸画屏系统",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/libpublic/public-item4.png",
          desc: "新书互动系统",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/libpublic/public-item5.png",
          desc: "多媒体互动大屏系统",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libPublic.scss";
</style>
